import { useState } from "react";

const HISTORY_DATA = {
  "2020-현재": [
    {
      year: "2025",
      items: [
        "굿리치 앱 다운로드 800만건 돌파",
        "헤럴드 경제 ‘제 30회 헤럴드 챔피언십’ GA부문 대상",
      ],
    },
    {
      year: "2024",
      items: ["굿리치 앱 다운로드 700만 돌파", "보험저널 ‘클린 GA’ 선정"],
    },
    {
      year: "2023",
      items: [
        "굿리치 주식회사 사명 변경",
        "굿리치 앱 다운로드 600만 돌파",
        "헤럴드경제 보험대상 ‘디지털혁신 GA부문 대상’",
        "다수 MOU 체결 (소상공인 보험·국가대표 선수협회)",
      ],
    },
    {
      year: "2022",
      items: [
        "보험추천시스템 런칭",
        "보험저널 ‘클린 GA’ 선정",
        "보험금 청구 150만 건 돌파",
      ],
    },
    {
      year: "2021",
      items: ["맘스다이어리 전략적 제휴"],
    },
    {
      year: "2020",
      items: [
        "산부인과 관리 ‘모아베베’ 전략적 제휴",
        "우수 매니저 프로필 서비스 도입",
        "현대해상 고객 관리 우수회사 인증",
      ],
    },
  ],

  "2010-2019": [
    {
      year: "2019",
      items: ["드림센터 보험전문 오픈", "현대해상 보험금 청구 MOU 체결"],
    },
    {
      year: "2018",
      items: ["보험 포털 서비스 오픈", "다수 보험사 고객감동경영상 수상"],
    },
    {
      year: "2016",
      items: [
        "엠담, 크라이베베, 차병원, 핑크다이어리 전략적 제휴",
        "(주)리더스금융판매 전략적 제휴",
        "성인보험 비교 앱 오픈",
        "(주)처음소리 앱 개발 성공",
      ],
    },
    {
      year: "2015",
      items: [
        "임산부 웹툰 연재 시작",
        "모바일 앱 페어셀 운영",
        "육아클럽 전략적 제휴",
        "모바일 사이트 전면 개편",
      ],
    },
    {
      year: "2013",
      items: [
        "태아보험넷 사이트 전면 개편",
        "텐박스, 베이비유, 메트로웨딩, 모닝글로리 전략적 제휴",
        "스마일켓, 스냅아카 전략적 제휴",
        "마이크로사이트 운영 시작",
      ],
    },
    {
      year: "2012",
      items: [
        "옥션, 잉글레시나, 다이치 전략적 제휴",
        "베베콤 인수 후 (주)처음소리 설립",
        "초음파 동영상 서비스 오픈",
        "현대해상 300억 매출 달성",
      ],
    },
    {
      year: "2011",
      items: [
        "인터파크hm 제휴 및 산모교실 개최",
        "아벤트, 브레비베, 콤비, 치코 전략적 제휴",
        "동양생명 200억 매출 달성",
      ],
    },
    {
      year: "2010",
      items: [
        "메리츠화재 영업우수 대리점 VIP 선정",
        "보험금 청구 및 사후 처리 서비스 ISO9001 인증 획득",
      ],
    },
  ],

  "2001-2009": [
    {
      year: "2009",
      items: [
        "맘스 다이어리, 세이베베, 이플러스 전략적 제휴",
        "NS홈쇼핑, CJ오쇼핑 채널 확장",
        "강남·송파·청담·서울지점 확장",
        "[베이비페어] 베페보험몰 오픈",
      ],
    },
    {
      year: "2008",
      items: ["전국 10개 주요 도시 베이비 샤워 주관"],
    },
    {
      year: "2007",
      items: ["다이렉트플라자 성인보험 분야 사업 확장"],
    },
    {
      year: "2006",
      items: [
        "베베콤 전략적 제휴",
        "베베콤 이중언어 교육 및 영어 태교 서비스 개시",
        "제1회 좋은 부모 되기 강연회 주최",
      ],
    },
    {
      year: "2005",
      items: [
        "(주)태아보험넷 강남 지사 법인 설립",
        "인터넷 순위 사이트 태아보험 분야 1위",
        "연매출 45억 원 달성",
      ],
    },
    {
      year: "2004",
      items: [
        "WORI&INSU, 라이프코드 전략적 제휴",
        "월 매출 1억 원 달성",
        "한국보험신문 태아보험 분야 선두주자 표창",
      ],
    },
    {
      year: "2003",
      items: [
        "정식 오픈",
        "국제 임신·출산·육아 용품 박람회 참가",
        "자체 사고보상 처리 서비스팀 신설",
      ],
    },
    {
      year: "2002",
      items: ["비교 견적 시스템 개발", "국내 생보사 대리점 등록"],
    },
    {
      year: "2001",
      items: ["태아보험넷 개발 착수"],
    },
  ],
};

const INCENTIVE_DATA = {
  "2020-현재": [
    {
      year: "2026",
      items: ["1/29 ~ 2/1 일본 클럽메드"],
    },
    {
      year: "2025",
      items: [
        "04/03 ~ 04/07 후쿠오카",
        "11/05 ~ 11/08 마카오",
        "(A팀: 04/03 ~ 04/05, B팀: 04/05 ~ 04/07)",
      ],
    },
    {
      year: "2024",
      items: [
        "01/11 ~ 01/15 보홀",
        "11/07 ~ 11/11 괌",
        "(A팀: 11/07 ~ 11/10, B팀: 11/08 ~ 11/11)",
      ],
    },
    {
      year: "2023",
      items: ["04/12 ~ 04/16 다낭 & 호이안"],
    },
    {
      year: "2022",
      items: ["코로나로 미진행"],
    },
    {
      year: "2021",
      items: ["코로나로 미진행"],
    },
    {
      year: "2020",
      items: ["02/07 ~ 02/11 코타키나발루"],
    },
  ],

  "2017-2019": [
    {
      year: "2019",
      items: ["04/11 ~ 04/17 하와이", "07/03 ~ 07/07 다낭 & 호이안"],
    },
    {
      year: "2018",
      items: ["04/11 ~ 04/15 사이판"],
    },
    {
      year: "2017",
      items: ["04/20 ~ 04/24 빈탄"],
    },
  ],
};

function Section({ title, data }) {
  const tabs = Object.keys(data);
  const [active, setActive] = useState(tabs[0]);

  return (
    <section className="mb-20 md:mb-24">
      <div className="mb-8 flex flex-col gap-5 md:mb-12 md:flex-row md:items-start md:justify-between">
        <h2 className="text-[28px] font-extrabold text-secondary md:text-[36px]">
          {title}
        </h2>

        <div className="flex flex-wrap items-center gap-y-2 text-base font-semibold md:text-[18px]">
          {tabs.map((tab, idx) => (
            <div key={tab} className="flex items-center">
              {idx > 0 ? (
                <span className="mx-3 text-secondary/30 md:mx-4">|</span>
              ) : null}

              <button
                type="button"
                onClick={() => setActive(tab)}
                className={`transition-all ${
                  active === tab
                    ? "text-main opacity-100"
                    : "text-secondary opacity-50"
                }`}
              >
                {tab}
              </button>
            </div>
          ))}
        </div>
      </div>

      <div className="space-y-10 md:space-y-16">
        {data[active].map((item) => (
          <div
            key={item.year}
            className="flex flex-col gap-3 md:flex-row md:items-start md:gap-10"
          >
            <div className="w-full text-[30px] font-semibold leading-none text-secondary md:w-[96px] md:shrink-0 md:text-[32px]">
              {item.year}
            </div>

            <div className="space-y-1.5 pl-[2px] text-base leading-7 text-gray-700 md:space-y-2 md:pl-0 md:text-[18px]">
              {item.items.map((text, i) => (
                <p key={i}>{text}</p>
              ))}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}

export default function HistoryPage() {
  return (
    <main className="bg-white">
      <div className="mx-auto max-w-5xl px-5 py-12 md:px-8 md:py-20">
        <Section title="히스토리" data={HISTORY_DATA} />
        <Section title="해외 인센티브 연혁" data={INCENTIVE_DATA} />
      </div>
    </main>
  );
}
